<div class="general-body bg-light">
    <!-- cards -->
    <div class="background-container">
        <div class="background-image">
            <img src="../../../assets/img/Backkground.png" alt="Background Image" class="background-pic" draggable="false">
        </div>
        <div class="cards-container container">
            <div class="cards-dash row g-3">

                <!-- Vendor new status card -->
                <div class="col-lg-4 col-md-6 col-12">
                    <div class="card upper-cards">
                        <div class="card-body">


                            <div class="row pt-2">



                                <div class="col-9 title-pad ">
                                    <h6 class="card-title title-card">Vendor application</h6>
                                </div>

                                <div class="col-3 d-flex justify-content-end align-items-center">
                                    <span class="title-card-status d-flex justify-content-center align-items-center p-1 text-end" [ngStyle]="{'color': getStatusColor()}" style="font-weight: bold;">
                                        {{ getVendorStatusDisplay() }}
                                    </span>
                                </div>

                            </div>

                            <div class="row pt-2">



                                <div class="col-9">
                                    <p class="card-title ">Registration submission:</p>
                                </div>



                                <div class="col-3 d-flex justify-content-end align-items-center">
                                    <p class="card-title">{{formatDate(vendor?.applicationSubmissionDate)}}</p>
                                </div>

                            </div>
                            <div class="row pt-2">
                                <div class="col-9">
                                    <p class="card-title">Last modification date:</p>
                                </div>
                                <div class="col-3 d-flex justify-content-end align-items-center">
                                    <p class="card-title">{{formatDate(vendor?.lastApplicationModifyDate)}}</p>
                                </div>
                            </div>

                            <!-- Vendor Application Action Buttons -->
                            <div class="d-flex flex-wrap justify-content-between align-items-center pt-3 gap-2">
                                <div>
                                    <!-- View Application: secondary always; primary only when submitted (not Draft) -->
                                    <div *ngIf="user?.ContactType === 'Secondary' || vendor?.status !== 'Draft'">
                                        <a [routerLink]="['/', AppConstants.ROUTES.VendorApplication]" [queryParams]="{ viewMode: true }" class="vendor-action-btn">
                                            <i class="fas fa-eye"></i>
                                            <span>View Application</span>
                                        </a>
                                    </div>
                                    <!-- Continue Application: primary only, and only when Draft -->
                                    <div *ngIf="vendor?.status === 'Draft' && user?.ContactType === 'Primary'">
                                        <a [routerLink]="['/', AppConstants.ROUTES.VendorApplication]" class="vendor-action-btn">
                                            <i class="fas fa-arrow-right"></i>
                                            <span>Continue Application</span>
                                        </a>
                                    </div>
                                </div>

                                <div>
                                    <!-- Edit Application Button -->
                                    <div *ngIf="canEditApplication()">
                                        <a [routerLink]="['/', AppConstants.ROUTES.VendorApplication]" class="vendor-action-btn">
                                            <i class="fas fa-edit"></i>
                                            <span>Edit Application</span>
                                        </a>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>

                <!-- Tenders Card -->
                <div class="col-lg-4 col-md-6 col-12">
                    <div class="card upper-cards">
                        <div class="card-body">
                            <!-- Title and Status Row -->
                            <div class="row pt-2">
                                <div class="col-9 title-pad">
                                    <h6 class="card-title title-card">Tender List</h6>
                                </div>
                                <div class="col-3 d-flex justify-content-end align-items-center">

                                </div>
                            </div>

                            <!-- Tender Number Row -->
                            <div class="row pt-2 align-items-center">
                                <div class="col-9 d-flex align-items-center">
                                    <p class="card-title mb-0">Open private tenders</p>
                                </div>
                                <div class="col-3 d-flex justify-content-end align-items-center">
                                    <div class="rectangle-highlight">
                                        {{privateTenderCount}}
                                    </div>
                                </div>
                            </div>


                            <div class="row pt-2 align-items-center">
                                <div class="col-9 d-flex align-items-center">
                                    <p class="card-title  mb-0">Open public tenders </p>
                                </div>
                                <div class="col-3 d-flex justify-content-end align-items-center">
                                    <div class="rectangle-highlight">
                                        {{publicTenderCount}}
                                    </div>
                                </div>
                            </div>






                        </div>
                    </div>
                </div>

                <!-- Bids Card -->
                <div class="col-lg-4 col-md-6 col-12">
                    <div class="card upper-cards">
                        <div class="card-body">
                            <!-- Title and Status Row -->
                            <div class="row pt-2">
                                <div class="col-9 title-pad">
                                    <h6 class="card-title title-card">My Bids</h6>
                                </div>
                                <div class="col-3 d-flex justify-content-end align-items-center">

                                </div>
                            </div>

                            <!-- Tender Number Row -->
                            <div class="row pt-2 align-items-center">
                                <div class="col-9 d-flex align-items-center">
                                    <p class="card-title  mb-0">Open bid</p>
                                </div>
                                <div class="col-3 d-flex justify-content-end align-items-center">
                                    <div class="rectangle-highlight">
                                        {{ openBidCount }}
                                    </div>
                                </div>
                            </div>


                            <div class="row pt-2 align-items-center">
                                <div class="col-9 d-flex align-items-center">
                                    <p class="card-title mb-0">Submitted bid</p>
                                </div>
                                <div class="col-3 d-flex justify-content-end align-items-center">
                                    <div class="rectangle-highlight">
                                        {{ submittedBidCount }}
                                    </div>
                                </div>
                            </div>






                        </div>
                    </div>
                </div>


                <!-- Bids Card
                <div class="col-lg-4 col-md-6 col-12">
                    <div class="card upper-cards">
                        <div class="card-body">
                            <div class="row pt-2">
                                <div class="col-12 title-pad ">
                                    <h5 class="card-title title-card fw-bold">Bids</h5>
                                </div>
                            </div>
                            <div class="card-details pt-2">
                                <p class="card-text">2024-460 - OECM posted the Signage Products and Related Services RFP on OTP :</p>
                            </div>
                            <div class="row pt-2">
                                <div class="col-9">
                                    <p class="card-title fw-bold">Bid Closing Date</p>
                                </div>
                                <div class="col-3">
                                    <p class="card-title fw-bold">Bid Status</p>
                                </div>
                            </div>
                            <div class="row pt-2">
                                <div class="col-9">
                                    <p class="card-title fw-bold">Mon May 27, 2024 2:00 PM (EDT)</p>
                                </div>
                                <div class="col-3">
                                    <span class="progress-title-3 d-flex justify-content-center align-items-center border p-1">
                                    Open
                                </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->

            </div>
        </div>
    </div>

    <div class="container">
        <div class="row g-4">

            <!-- Tenders Card Section -->
            <div class="col-12 col-sm-6 ">
                <div class="card w-100 mb-3 tenders-card-section">
                    <div class="card-body">
                        <h5 class="fw-bold">Tender List</h5>
                        <p class="card-text">{{ tenderMessage }}</p>
                        <a class="dashboard-card-link" [routerLink]="['/', AppConstants.ROUTES.TENDER]">View all</a>
                    </div>
                </div>
            </div>

            <!-- Bids Card Section -->
            <div class="col-12 col-sm-6">
                <div class="card w-100 mb-3 bids-card-section">
                    <div class="card-body">
                        <h5 class="fw-bold">Bid list</h5>
                        <p class="card-text">{{this.bisMessage}}</p>
                        <a class="dashboard-card-link" [routerLink]="['/', AppConstants.ROUTES.BID]">View all</a>                        
                    </div>
                </div>
            </div>

        </div>
    </div>

    <div class="container my-4">
        <div class="row g-4">

            <div class="col-12 col-lg-8">
                <div class="table-responsive h-100">
                    <div class="filter-container d-flex justify-content-between p-3 align-items-center bg-white">
                        <div class="latest-tender">
                            <h5>Latest tenders</h5>
                        </div>
                    </div>

                    <p-table [value]="filteredTenders" [paginator]="false">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Reference</th>
                                <th>Description</th>
                                <th>Start</th>
                                <th>Closure</th>
                                <th>Status</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-tender>
                            <tr>
                                <td>{{ tender.tenderID }}</td>
                                <td>{{ tender.description }}</td>
                                <td>{{ tender.startDate | date: 'dd/MM/yyyy' }}</td>
                                <td>{{ tender.closureDate | date: 'dd/MM/yyyy' }}</td>
                                <td>
                                    <span class="status-badge" [ngStyle]="{
                                        'color': getTenderStatusColor(tender.status).color,
                                        'background-color': getTenderStatusColor(tender.status).backgroundColor
                                    }">
                                        {{ tender.status }}
                                    </span>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>


                    <div class="filter-container d-flex justify-content-between p-3 align-items-center bg-white d-none">
                        <div class="latest-tender">
                            <h5 class="description-line light-text-h">
                                <!-- Showing 1-5 from 15 -->
                            </h5>
                        </div>
                        <div class="filter-section">
                            <nav aria-label="Page navigation example">
                                <ul class="pagination justify-content-center">
                                    <li class="page-item">
                                        <a class="page-link" tabindex="-1" aria-disabled="true">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16">
                                                <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"/>
                                            </svg>
                                        </a>
                                    </li>
                                    <li class="page-item active"><a class="page-link">1</a></li>
                                    <li class="page-item">
                                        <a class="page-link">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                                                <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1 0-.708l10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
                                            </svg>
                                        </a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>


            <!-- Double Card Section -->
            <div class="col-12 col-lg-4">
                <div class="card messages-container h-100">
                    <div class="card-body">
                        <div class="title-msg">
                            <h5 class="mb-0">Messages</h5>
                        </div>

                        <!-- If there are no messages, show the SVG and the message -->
                        <div *ngIf="Messages.length === 0" class="no-messages text-center">
                            <svg width="132" height="131" viewBox="0 0 132 131" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="66" cy="65.5" r="65.5" fill="#532E60" fill-opacity="0.23"/>
                                <circle cx="66.0002" cy="66.0504" r="42.9328" fill="white" fill-opacity="0.28"/>
                                <path d="M84.348 62.3805V71.5542C84.348 80.7278 80.6785 84.3973 71.5049 84.3973H60.4965C51.3228 84.3973 47.6533 80.7278 47.6533 71.5542V60.5458C47.6533 51.3721 51.3228 47.7026 60.4965 47.7026H69.6701" stroke="#532E60" stroke-width="1.65126" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M84.3478 62.3805H77.0089C71.5047 62.3805 69.6699 60.5458 69.6699 55.0416V47.7026L84.3478 62.3805Z" stroke="#532E60" stroke-width="1.65126" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M56.8262 67.8853H67.8346" stroke="#532E60" stroke-width="1.65126" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M56.8262 75.2241H64.1651" stroke="#532E60" stroke-width="1.65126" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <p class="mt-3">There are no messages</p>
                        </div>

                        <!-- Show messages if available -->
                        <div *ngFor="let message of Messages.slice(-3)" class="message-details p-3 mt-3">
                            <div class="message-general d-flex">
                                <div class="message-icon col-2">
                                    <svg width="47" height="46" viewBox="0 0 47 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="0.5" width="46" height="46" rx="23" fill="#FFF4FF" />
                                        <path d="M28.5 20C28.5 23.87 25.14 27 21 27L20.07 28.12L19.52 28.78C19.05 29.34 18.15 29.22 17.84 28.55L16.5 25.6C14.68 24.32 13.5 22.29 13.5 20C13.5 16.13 16.86 13 21 13C24.02 13 26.63 14.67 27.8 17.07C28.25 17.96 28.5 18.95 28.5 20Z" stroke="#532E60" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M33.5003 23.8598C33.5003 26.1498 32.3203 28.1798 30.5003 29.4598L29.1603 32.4098C28.8503 33.0798 27.9503 33.2098 27.4803 32.6398L26.0003 30.8598C23.5803 30.8598 21.4203 29.7898 20.0703 28.1198L21.0003 26.9998C25.1403 26.9998 28.5003 23.8698 28.5003 19.9998C28.5003 18.9498 28.2503 17.9598 27.8003 17.0698C31.0703 17.8198 33.5003 20.5798 33.5003 23.8598Z" stroke="#532E60" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M18.5 20H23.5" stroke="#532E60" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <div class="message-text col-10">
                                    <h6 class="mb-0">{{ message.moudle === 'VendorChat' ?'General' : message.moudle }}</h6>
                                    <p class="light-text-m">{{ message.vendorID }}</p>
                                </div>
                            </div>
                            <div class="message-information d-flex mt-2">
                                <div class="col-2 message-icon"></div>
                                <div class="col-10">
                                    <p class="need-information mb-0">{{ message.messageContent }}</p>
                                    <p class="light-text-w">{{ message.CreatedAt | date:'medium' }}</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>



        </div>
    </div>
</div>


<!---------------------------------------------- notifications ----------------------------------------------------->